// web/src/routes/horses/new.jsx
// Add Horse — full profile entry via the shared HorseForm. Required: name.
// Posts to POST /horses (owner/manager only) and navigates to the new horse's
// detail page on success. A new horse belongs to the barn; assigning a client
// owner happens on the detail page (OwnersCard).

import { useNavigate, Link } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import HorseForm from '../../components/horse/HorseForm';

export default function HorseNew() {
  const navigate = useNavigate();
  const qc = useQueryClient();

  const create = useMutation({
    mutationFn: (payload) => api.post('/horses', payload),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ['horses'] });
      navigate(`/horses/${res.id}`);
    },
  });

  return (
    <div className="max-w-xl mx-auto p-4">
      <Link to="/horses" className="text-sm text-ink-500 hover:text-ink-800">
        ← Horses
      </Link>

      <h1 className="mt-2 mb-6 text-2xl font-semibold">Add a horse</h1>

      <HorseForm
        mode="create"
        onSubmit={(payload) => create.mutate(payload)}
        submitting={create.isPending}
        submitError={create.isError ? friendlyError(create.error) : null}
      />

      <div className="mt-4">
        <Link to="/horses" className="text-sm text-ink-500 hover:text-ink-800">
          Cancel
        </Link>
      </div>
    </div>
  );
}

function friendlyError(err) {
  const code = err?.body?.error || err?.message;
  switch (code) {
    case 'missing_name':
      return 'Please enter a name.';
    case 'invalid_sex':
      return 'Please choose a valid sex.';
    case 'forbidden':
      return 'Only an owner or manager can add horses.';
    case 'no_active_barn':
      return 'No barn selected. Pick a barn and try again.';
    case 'unauthorized':
    case 'session_expired':
      return 'Your session expired. Please sign in again.';
    default:
      return 'Something went wrong adding the horse. Please try again.';
  }
}
